import { fetchApiData } from '../FetchISR'

const BASE_URL = process.env.NEXT_PUBLIC_API_BASE_URL

// Fetch similar properties based on property ID
export const fetchSimilarProperties = async (id) => {
  return fetchApiData(
    'similarProperties',
    `${BASE_URL}/v2/vacation-rental/similar-property/?property_uid=${id}`,
  )
}

// Fetch property details based on property ID
export const fetchPropertyDetails = async (id, checkin = "", checkout = "") => {
  const hasDates = Boolean(checkin && checkout)
  const url = `${BASE_URL}/v2/vacation-rental/property-detail/${id}${hasDates ? `?check_in=${checkin}&check_out=${checkout}` : ''}`

  // The dateless payload carries the property photos and gates the show-more
  // gallery render, so cache it (5 min, tag-revalidatable). Dated requests
  // carry live pricing/availability, so keep those dynamic.
  const result = await fetchApiData(
    'propertyDetails',
    url,
    hasDates ? {} : { revalidate: 300, tags: [`property-${id}`] },
  )
  return result
}

// Fetch property reviews based on property ID
export const fetchPropertyReviews = async (id, page) => {
  return fetchApiData(
    'propertyReviews',
    `${BASE_URL}/v2/vacation-rental/property-review/${id}/?page=${page}`,
  )
}

// Fetch property quick features
export const fetchPropertyQuickFeatures = async () => {
  const url = `${BASE_URL}/v1/rental/property/quick-feature/`

  return fetchApiData('propertyQuickFeatures', url)
}

// Fetch nearest availability for a property when no dates are provided
export const fetchNearestAvailability = async (propertyUid) => {
  return fetchApiData(
    'nearestAvailability',
    `${BASE_URL}/v2/vacation-rental/property-detail/${propertyUid}/nearest-availability/`,
  )
}
